import React from "react";
import { getPeriodCanvasCoords, getMonthStart, periodOverlapPeriods } from "../../../utils/graphUtils";
import { toDateString } from '../../../utils/date';
import styled from "styled-components";
import { Link } from "react-router-dom";
import { TooltipContainerStyle } from "../../Toggletip";
import { colors } from "../../colors/color";


const DEBUG = false;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function debug (header: string, message: any) { if (DEBUG) console.log(`${header}:`, message); }
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function debugLine (message: any) { if (DEBUG) console.log(message); }

export type TimelineGraphEvent = {
    id: string,
    title: string,
    description: string,
    linkUrl: string,
    start: Date,
    end: Date,
    color?: string;
};

type TimelineGraphYearRowProps = {
    graphWidthPx: number,
    rowHeightPx: number,
    yearMonthStart: Date,
    activities: TimelineGraphEvent[],
    color: string,
    firstRow?: boolean;
    eventGroupsTitle?: string;
};
export function TimelineGraphYearRow (props: TimelineGraphYearRowProps): JSX.Element
{
    const adjustedProps = { ...props, yearMonthStart: getMonthStart(props.yearMonthStart) };

    return <ActivityYearRowInternal {...adjustedProps} />;
}

export function ActivityYearRowInternal (props: TimelineGraphYearRowProps): JSX.Element
{
    type TimelineEvent = TimelineGraphEvent & { offsetPx: number, widthPx: number; };
    type SubRow = { events: TimelineEvent[]; };

    const subRows: SubRow[] = [{ events: [] }];
    debugLine('--- activityYearRow --------------------------');
    debug('grapWidth', props.graphWidthPx);
    debug('monthWidth', props.graphWidthPx / 12);
    debug('graphStartDate', toDateString(props.yearMonthStart));

    for (let i = 0; i < props.activities.length; i++)
    {
        debugLine('--- activity ' + (i + 1) + ' of ' + props.activities.length);
        const activity = props.activities[i];

        const coords =
            getPeriodCanvasCoords(props.yearMonthStart, activity, props.graphWidthPx);
        //getPeriodCoordinatesInYear(props.yearMonthStart, activity, props.graphWidthPx);
        if (coords === null)
            debugLine('no coords - out of graph area');
        else
        {
            debug('coords', `offset:${coords.leftOffsetPx}, width:${coords.widthPx}`);
            const newEvent = { ...activity, offsetPx: coords.leftOffsetPx, widthPx: coords.widthPx };
            const availableRow = subRows.find(sr => !periodOverlapPeriods(activity, sr.events));
            if (availableRow)
            {
                availableRow.events.push(newEvent);
            }
            else
            {
                subRows.push({ events: [newEvent] });
            }
        }
    }

    const monthCells = [];
    for (let i = 0; i < 12; i++)
    {
        monthCells.push(
            <MonthCell key={i} style={{
                position: 'absolute',
                marginLeft: i * props.graphWidthPx / 12,
                height: props.rowHeightPx + 1,
                width: props.graphWidthPx / 12
            }}>
            </MonthCell>
        );
    }

    
    return (
        <Wrapper style={{ height: props.rowHeightPx + 1 + 16 }}>
            <MonthCellsTop />
            <ActivityTitle>
                {props.eventGroupsTitle}
            </ActivityTitle>
            {monthCells}
            
            {subRows.map((sr, sri) =>
                sr.events.map((ev, evi) =>
                {
                    const rowHeight = (props.rowHeightPx - 1 * subRows.length - 1) / subRows.length;
                    const marginTop = sri * (rowHeight + 1) + 1;

                    return (
                        <Link key={sri + '_' + evi} to={ev.linkUrl}>
                            <EventBlock
                                style={{
                                    marginLeft: ev.offsetPx,
                                    marginTop: marginTop,
                                    width: ev.widthPx,
                                    height: rowHeight
                                }}
                                color={ev.color || props.color}>
                                <EventToolTip
                                    hexColor='#0f0'>
                                    <b>{ev.title}</b><br />
                                    <small dangerouslySetInnerHTML={{ __html: ev.description }} /><br />
                                    
                                    <small>{toDateString(ev.start)} - {toDateString(ev.end)}</small>
                                    {/* Possible error */}
                                    {/* {(props.periodFormat === undefined || props.periodFormat === 'to-from') &&
                                        <>
                                            <small>{toDateTimeString(ev.start)}</small> - <small>{toDateTimeString(ev.end)}</small>
                                        </>
                                    }

                                    {props.periodFormat === 'start' &&
                                        <>
                                            <small>{toDateTimeString(ev.start)}</small>
                                        </>
                                    } */}

                                </EventToolTip>
                            </EventBlock>
                        </Link>
                    );

                })
            )}
            
        </Wrapper>
    );
}

const Wrapper = styled.div`
    display: flex;
    position: relative;
    padding-top: 16px;
`;

const ActivityTitle = styled.div`
    position: absolute;
    font-size: 14px;
    font-weight: bold;
    color: #cdcdcd;
    top:0;
`


const MonthCellsTop = styled.div`
    border-top:1px solid #EEE;
    height:0px;
`;

const MonthCell = styled.div`
    border:1px solid #EEE;
`;

const EventToolTip = styled.div<{ hexColor: string; }>`
    ${TooltipContainerStyle}


    visibility: hidden;
    width: 250px;
    text-align: left;
    position: absolute;
    top: 25px;
    left: 50%;
    margin-left: -125px;
    opacity: 0;
    transition: opacity 0.3s;
`;

const EventBlock = styled.div<{ color: string; }>`
    position:absolute;
    background-color:${props => props.color};
    
    
    &:hover {
        border:1px solid ${colors.graphs.activityTimeline.hover};
        background-color: ${colors.graphs.activityTimeline.hover};
        & ${EventToolTip}{
            visibility: visible;   
            opacity: 1;
        }
    }
`;